/**
 * Character limits, shared with the backend checks (methods/src/common/inputLimits.ts):
 * 6,000 per advisor chat message, 4,000 per idea field (and the quick idea box).
 */
export const CHAT_MAX = 6000;
export const IDEA_FIELD_MAX = 4000;

/** Over the limit? */
export const overLimit = (value: string, max: number) => value.length > max;

/**
 * A quiet "5,600 / 6,000" that appears only within 10% of the limit, red with a short note once over.
 * Absolutely positioned by the caller's wrapper, or inline, so it never shifts the layout.
 */
export function CharCount({ value, max, overNote, style }: { value: string; max: number; overNote?: string; style?: React.CSSProperties }) {
  const n = value.length;
  if (n < max * 0.9) return null;
  const over = n > max;
  return (
    <span
      role={over ? 'alert' : undefined}
      style={{
        font: '500 11.5px var(--f-mono)',
        color: over ? 'var(--oxblood)' : 'var(--text-decorative)',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        ...style,
      }}
    >
      {n.toLocaleString()} / {max.toLocaleString()}
      {over && overNote ? ` · ${overNote}` : ''}
    </span>
  );
}
